import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'base-layout',
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.scss'],
})
export class BaseLayoutComponent implements OnInit {

  constructor () {
  }

  ngOnInit (): void {
  }
}
